module.exports = __webpack_public_path__ + "img/lekkerknuss.221debe7.png";